let dev = process.env.NODE_ENV !== 'production';
// let host = dev ? 'http://192.168.3.88:21010' : 'http://api.e-nongye.com.cn';
let host = dev ? 'http://localhost:21010' : 'https://api.e-nongye.com.cn';

export {
    host
}
